import { Form } from "antd";
import NumberFormat from "react-number-format";
import React from "react";
import { SetActiveFlows, SetBannerState } from "../../State/actions";
import { isValidPhoneNumber } from "../../utils";
import CognitoFlowState from "../../Constants/CognitoFlowState";
import { TextField } from "@material-ui/core";

const RegistrationFieldset = props => {
  const { c, activeProperty = {}, getFieldDecorator, dispatch, history } = props;
  const params = new URLSearchParams(window.location.search);
  const propCode = params.get("propCode");
  if (
    !propCode ||
    (activeProperty.hasOwnProperty("allowSelfSignup") && !activeProperty.allowSelfSignup)
  ) {
    dispatch(
      SetBannerState({
        type: "error",
        show: true,
        text: "You must specify a property to register for Domuso"
      })
    );
    dispatch(SetActiveFlows([CognitoFlowState.SIGN_IN, history]));
    return null;
  }

  return (
    <fieldset className={"register-fieldset"}>
      <div className={`${c.row} group`}>
        <Form.Item colon={false}>
          {getFieldDecorator("given_name", {
            validateFirst: true,
            rules: [
              { required: true, message: "First name is required." },
              {
                validator: async (_, value) => {
                  return String(value).trim().length === 0
                    ? Promise.reject("First name is required.")
                    : Promise.resolve();
                }
              }
            ]
          })(<TextField label="First Name" />)}
        </Form.Item>
      </div>
      <div className={`${c.row} group`}>
        <Form.Item colon={false}>
          {getFieldDecorator("family_name", {
            validateFirst: true,
            rules: [
              { required: true, message: "Last name is required." },
              {
                validator: async (_, value) => {
                  return String(value).trim().length === 0
                    ? Promise.reject("Last name is required.")
                    : Promise.resolve();
                }
              }
            ]
          })(<TextField label="Last Name" />)}
        </Form.Item>
      </div>
      <div className={`${c.row} group`}>
        <Form.Item colon={false}>
          {getFieldDecorator("email", {
            rules: [
              { required: true, message: "Email is required" },
              {
                type: "email",
                message: "Invalid Email"
              },
              { whitespace: false }
            ]
          })(<TextField label="Email" />)}
        </Form.Item>
      </div>
      <div className={`${c.row} group`}>
        <Form.Item colon={false}>
          {getFieldDecorator("phone_number", {
            rules: [
              { required: true, message: "Phone number is required" },
              {
                validator: async (_, value) => {
                  if (!value || isValidPhoneNumber(value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject("Phone number is invalid.");
                }
              },
              { whitespace: false }
            ]
          })(
            <NumberFormat
              className="phone-field"
              customInput={TextField}
              label="Phone Number"
              renderText={value => <div>{value}</div>}
              format="(###) ###-####"
              mask="_"
            />
          )}
        </Form.Item>
      </div>
    </fieldset>
  );
};

export default RegistrationFieldset;
